import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDiamond = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-diamond';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.976 5.09C2.172 9.321 2.073 9.475 2.107 9.531 2.177 9.649 11.97 21.12 12 21.12c.036 0 9.876-11.541 9.902-11.614.01-.025-.907-1.441-2.037-3.146l-2.053-3.1-5.805-.01-5.806-.01zm3.84.7a366 366 0 0 1-.648 1.97l-.315.94-1.726.01c-.95.006-1.727.002-1.727-.008s.584-.902 1.298-1.981L6.996 4.76h2.155zm5.094.92c.358 1.073.65 1.964.65 1.98s-1.152.03-2.56.03-2.56-.013-2.56-.03c0-.016.292-.907.65-1.98l.649-1.95h2.522zm4.392.012c.714 1.079 1.298 1.97 1.298 1.98s-.777.014-1.727.008l-1.726-.01-.355-1.06c-.194-.583-.486-1.47-.649-1.97l-.294-.91h2.154zM8.726 13.08c.479 1.573.867 2.874.862 2.891s-1.002-1.135-2.215-2.56L4.9 10.51l-.267-.311 1.611.011 1.61.01zm5.834-2.843c0 .062-2.507 8.284-2.535 8.311a.035.035 0 0 1-.05 0c-.027-.027-2.535-8.246-2.535-8.309 0-.025.91-.039 2.56-.039 1.542 0 2.56.015 2.56.037m4.111.774-2.469 2.899c-.978 1.148-1.784 2.081-1.792 2.074-.013-.014 1.701-5.691 1.737-5.754.01-.017.737-.03 1.616-.03h1.598z"
    })
  }));
});
export default SvgDiamond;